<template>
  <div
    id="app"
    @click="isDo()"
  >
    <!-- 回頂部 -->
    <font-awesome-icon
      class="go-top app-top no-print"
      icon="angle-double-up"
      size="3x"
      v-if="btnFlag"
      @click="backTop"
    />
    <!-- 主版 -->
    <div class="sView out-of-range font-weight-bold font app-img">
      <!-- 彈跳視窗 -->
      <ModalAlert />
      <webalert />
      <Loading />
      <!-- 內容版 -->
      <router-view />
    </div>
    <!-- 底板 -->
    <Footers
      class="sFooter font-weight-bold no-print"
      style="font-size: 16px;"
    />
  </div>
</template>

<script>
import $ from 'jquery'
import md5 from 'js-md5'
import ModalAlert from '@/components/Features/ModalAlert'
import webalert from '@/components/Features/webAlert'
import Footers from '@/components/Layout/Footer'
import Loading from '@/components/Features/Loading'
export default {
  name: 'App',
  components: {
    ModalAlert,
    webalert,
    Footers,
    Loading
  },
  mounted () {
    // 修正IE切換頁面失效
    let vm = this
    window.addEventListener('scroll', vm.scrollToTop)
    if (!!window.ActiveXObject || 'ActiveXObject' in window) {
      window.addEventListener(
        'hashchange', () => {
          let currentPath = window.location.hash.slice(1)
          if (vm.$route.path !== currentPath) {
            vm.$router.push(currentPath)
          }
        }, false
      )
    }
  },
  data () {
    return {
      btnFlag: '',
      lastTime: null, // 最後一次點擊時間
      currentTime: null, // 目前點擊時間
      timeOut: 30 * 60 * 1000 // 設定閒置時間： 30分鐘
    }
  },
  created () {
    this.lastTime = new Date().getTime() // 紀錄當前時間
  },
  // 監聽頁面滾動事件
  destroyed () {
    window.removeEventListener('scroll', this.scrollToTop)
  },
  methods: {
    // 點擊圖片回到頂部方法
    backTop () {
      let vm = this
      let timer = setInterval(() => {
        let ispeed = Math.floor(-vm.scrollTop / 5)
        document.documentElement.scrollTop = document.body.scrollTop = vm.scrollTop + ispeed
        if (vm.scrollTop === 0) {
          clearInterval(timer)
        }
      }, 16)
    },
    // 為了計算距離頂部的高度，當高度大於60顯示 回頂部圖標，小於60則隱藏
    scrollToTop () {
      let vm = this
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      vm.scrollTop = scrollTop
      if (vm.scrollTop > 0) {
        vm.btnFlag = true
      } else {
        vm.btnFlag = false
      }
    },
    // 閒置登出狀態判斷
    isDo () {
      let vm = this
      // 記錄這次點擊的時間
      vm.currentTime = new Date().getTime()
      // 判斷上次最後一次點擊的時間和這次點擊的時間間隔是否大於3分鐘
      if (vm.currentTime - vm.lastTime > vm.timeOut) {
        vm.$bus.$emit('NavLoginOut', 'false') // Nav
        vm.$bus.$emit('MenuLoginOut', 'false') // Menu
        vm.$bus.$emit('NavLoginOutAdmin', 'false')
        vm.$bus.$emit('LoginOutnAdminMenu', 'false')
        const UserType = localStorage.getItem('A_UserType')
        const BackendPrivilege = md5('職員')
        vm.$bus.$emit('Modals', '登出成功。')
        $('#CheckOk').modal('show')
        vm.lastTime = new Date().getTime()
        localStorage.removeItem('A_UserType')
        if (UserType === BackendPrivilege) {
          vm.$router.push('/admin/login')
        } else {
          vm.$router.push('/home/news')
        }
      } else {
        // 如果在3分鐘內點擊，則把這次點擊的時間記錄覆蓋掉之前存的最後一次點擊的時間
        vm.lastTime = new Date().getTime()
      }
    }
  }
}
</script>

<style lang="scss">
  @import "./assets/All.scss";
  @import "./assets/components.scss";
</style>
